import { render, staticRenderFns } from "./ExpenseCenter.vue?vue&type=template&id=084fe5a2&"
import script from "./ExpenseCenter.vue?vue&type=script&lang=js&"
export * from "./ExpenseCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports